/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UIConstants from "../UIConstants";
import MandantUtil from "./Utils/MandantUtil";

const baseUrl = window.location.host;
const isHttps = window.location.protocol === "https:";
const systemPath = UIConstants.uiSysPath;
const mandant = MandantUtil.ermittleMandant(window.location.pathname);
const isSystem = mandant === systemPath;
const isReactDevelopmentBuild = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const istBuchungsportal = window.location.pathname.indexOf("/buchungsportal") > 0;
const istBeta = baseUrl.startsWith("beta.");

export const ermittleMandantApiUrl = (mandant: string) => `http${isHttps ? "s" : ""}://${baseUrl}/${mandant}/${UIConstants.api}`;
export const ermittleMandantUIUrl = (mandant: string) => `http${isHttps ? "s" : ""}://${baseUrl}/${mandant}/${UIConstants.ui}`;
export const ermittleMandantRestApiUrl = (mandant: string) => `http${isHttps ? "s" : ""}://${baseUrl}/${mandant}/${UIConstants.restApi}`;
export const ermittleMandantUrl = (mandant: string) => `http${isHttps ? "s" : ""}://${baseUrl}/${mandant}`;

export const environment = {
    baseUrl: `http${isHttps ? "s" : ""}://${baseUrl}/`,
    mandantUrl: `http${isHttps ? "s" : ""}://${baseUrl}/${mandant}`,
    httpsBaseUrl: `http${isHttps ? "s" : ""}://${baseUrl}/${mandant}/${UIConstants.api}`,
    sysBaseUrl: `http${isHttps ? "s" : ""}://${baseUrl}/${systemPath}/${UIConstants.api}`,
    sysUiBaseUrl: `http${isHttps ? "s" : ""}://${baseUrl}/${systemPath}/${UIConstants.ui}`,
    restApiBaseUrl: `http${isHttps ? "s" : ""}://${baseUrl}/${mandant}/${UIConstants.restApi}`,
    uiBaseUrl: `http${isHttps ? "s" : ""}://${baseUrl}/${mandant}/${UIConstants.ui}`,
    wssBaseUrl: `ws${isHttps ? "s" : ""}://${baseUrl}/${mandant}/${UIConstants.api}`,
    infoUrl: (message: string, redirectUri?: string) =>
        `http${isHttps ? "s" : ""}://${baseUrl}/${systemPath}/info?message=${encodeURI(message)}&redirectUri=${redirectUri ?? ""}`,
    mandant,
    isSystem,
    isReactDevelopmentBuild,
    istBuchungsportal,
    istBeta,
};